(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-finder"] && !Shopify.designMode) return;
  try {
    
(function(){
  var w=document.querySelector('.dch-selwrap'); if(w){w.id='dch-selector';}
  var F=window.DC_FITMENT||{};
  var brand=document.querySelector('.dch-brand'),model=document.querySelector('.dch-model'),year=document.querySelector('.dch-year'),btn=document.querySelector('.dch-fitbtn');
  if(!brand||!btn)return;
  function opt(sel,v,t){var o=document.createElement('option');o.value=v;o.textContent=t;sel.appendChild(o);}
  Object.keys(F).sort().forEach(function(b){opt(brand,b,b);});
  function buildModels(){
    model.innerHTML='<option value="">Select Model</option>';year.innerHTML='<option value="">Select Year</option>';year.disabled=true;
    if(!brand.value||!F[brand.value]){model.disabled=true;return;}
    Object.keys(F[brand.value]).sort().forEach(function(m){opt(model,m,m);});
    model.disabled=false;
  }
  function buildYears(){
    year.innerHTML='<option value="">Select Year</option>';
    if(!model.value||!F[brand.value]||!F[brand.value][model.value]){year.disabled=true;return;}
    var gens=(F[brand.value][model.value]||[]).slice().sort(function(a,b){return b.yearStart-a.yearStart;});
    var generic=gens.length===1&&(gens[0].yearEnd-gens[0].yearStart>=15);
    if(generic){opt(year,'all','All years');}else{opt(year,'all','Not sure / show all years');gens.forEach(function(g){var label=(g.yearEnd-g.yearStart>=15)?'All years':(g.yearStart+'–'+g.yearEnd);opt(year,g.yearStart+'-'+g.yearEnd,label);});}
    year.disabled=false;
  }
  brand.addEventListener('change',buildModels);
  model.addEventListener('change',buildYears);
  btn.addEventListener('click',function(){
    var b=brand.value,m=model.value,yv=year.value||'all';
    if(b&&m){window.location.href='/pages/fit?b='+encodeURIComponent(b)+'&m='+encodeURIComponent(m)+'&y='+encodeURIComponent(yv);return;}
    window.location.href='/collections/all';
  });
  function reinit(){if(!brand.value||!F[brand.value])return;var sm=model.value,sy=year.value;buildModels();if(sm&&F[brand.value][sm]){model.value=sm;buildYears();if(sy){year.value=sy;}}}
  window.addEventListener('pageshow',reinit);
  reinit();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-spyro"] && !Shopify.designMode) return;
  try {
    
(function(){
  function bind(){
    var btn=document.querySelector('.dch-ed__cta a[href="#dc-finder"]');
    if(!btn||btn.__dcb)return;
    var tgt=document.getElementById('dc-finder')||document.querySelector('.dch-selwrap');
    if(!tgt)return; btn.__dcb=1;
    btn.addEventListener('click',function(e){
      e.preventDefault();
      var y=tgt.getBoundingClientRect().top+window.pageYOffset-90;
      try{window.scrollTo({top:y,behavior:'smooth'});}catch(_){window.scrollTo(0,y);}
      setTimeout(function(){if(Math.abs(window.pageYOffset-y)>4)window.scrollTo(0,y);},60);
      var s=tgt.querySelector('select,button');
      if(s)setTimeout(function(){try{s.focus({preventScroll:true});}catch(_){}} ,420);
    });
  }
  if(document.readyState!=='loading')bind();else document.addEventListener('DOMContentLoaded',bind);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
